import { getCurrentInstance, computed } from "@vue/composition-api";

export { computed };
export function useStore() {
  const vm = getCurrentInstance();
  if (!vm) {
    throw new Error('You must use this function within the "setup()" method');
  }
  const { $store } = "proxy" in vm ? vm.proxy : vm;
  return $store;
}
